import styled from 'styled-components'
import { INTER } from '@styles/fonts'
import { NEUTRAL_100, NEUTRAL_300, PRIMARY, PALE_BLUE, VIOLET_800 } from '@styles/colors'

export const RecentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 16px;
`

export const RecentLabel = styled.span`
  font-family: ${INTER.semiBold};
  font-size: 14px;
  color: ${NEUTRAL_300};
`

export const RecentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 168px;
`

export const RecentItem = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-shrink: 0;
  width: 100%;
  padding: 14px 16px;
  background: white;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 12px;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s, background 0.15s;

  &:hover {
    border-color: ${PRIMARY};
    background: ${PALE_BLUE};
  }
`

export const RecentNumber = styled.span`
  font-family: ${INTER.regular};
  font-size: 15px;
  color: ${VIOLET_800};
`
